import React from 'react';
import './FastCare.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faClock } from '@fortawesome/free-solid-svg-icons';

// Import location images
import springcreekImage from '../assets/springcreek_location.webp';
import elkoImage from '../assets/elko_location.jpeg';

const FastCare = () => {
  const locations = [
    {
      name: 'Spring Creek',
      address: '250 Country Club Pkwy, Spring Creek, NV',
      phone: '775-738-3000',
      hours: '8:00 AM - 8:00 PM',
      days: '7 Days a Week',
      image: springcreekImage,
      mapLink: 'https://www.google.com/maps/place/Aspen+Quick+Care/data=!4m2!3m1!1s0x0:0x990bd38b43800591?sa=X&ved=1t:2428&ictx=111'
    },
    {
      name: 'Elko',
      address: '2511 Mountain City Hwy, Elko, NV',
      phone: '775-993-2800',
      hours: '8:00 AM - 8:00 PM',
      days: '7 Days a Week',
      image: elkoImage,
      mapLink: 'https://www.google.com/maps/place/Aspen+Quick+Care/@40.8371489,-115.7930719,17z/data=!3m1!4b1!4m6!3m5!1s0x80a607c315fb2205:0x659a2e1d78f0a22f!8m2!3d40.8371489!4d-115.7930719!16s%2Fg%2F11hzqhclhx?entry=ttu&g_ep=EgoyMDI1MTIwMi4wIKXMDSoASAFQAw%3D%3D'
    }
  ];

  return (
    <section id="fast-care" className="fast-care">
      <div className="container">
        <div className="fast-care-content">
          <div className="fast-care-text">
            <div className="heart-icon-circle mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-heart text-primary">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
            </div>
            <h2>Fast, Quality Care.<br />When You Need It Most</h2>
            <p>At Aspen Quick Care, we provide immediate medical attention and primary care for non-life-threatening conditions. 
            Our experienced medical team is ready to treat injuries, illnesses, and health concerns with minimal wait times. 
            Walk-ins welcome.</p>
          </div>
          
          <div className="locations-container">
            <div className="locations-grid">
              {locations.map((location, index) => (
                <div className="location-card" key={index}>
                  <div className="location-image">
                    <img src={location.image} alt={`${location.name} Location`} />
                  </div>
                  <div className="location-content">
                    <h3>{location.name}</h3>
                    <div className="location-details">
                      <div className="location-detail">
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" />
                        <span 
                          onClick={() => window.open(location.mapLink, '_blank')}
                          style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        >
                          {location.address}
                        </span>
                      </div>
                      <div className="location-detail">
                        <FontAwesomeIcon icon={faPhone} className="icon" />
                        <a 
                          href={`tel:${location.phone.replace(/[^0-9]/g, '')}`}
                          style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                          {location.phone}
                        </a>
                      </div>
                      <div className="location-detail">
                        <FontAwesomeIcon icon={faClock} className="icon" />
                        <div>
                          <div>{location.hours}</div>
                          <div className="days">{location.days}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FastCare;
